import { EXTERNAL_LINK } from "@/config/external-links";
import { AVAILABLE_LANGUAGE } from "@/shared/models";
import { getSettingsStoreLanguage } from "@/shared/stores";

export const getFaqLink = () => {
  const language = getSettingsStoreLanguage();

  return language === AVAILABLE_LANGUAGE.EN
    ? EXTERNAL_LINK.FAQ.EN
    : EXTERNAL_LINK.FAQ.ES;
};
